import { ref } from "vue";
const alerts = ref([]);

export function useUiDialog() {
  function info(title, options = {}) {
    const model = {
      id: `alert-${Math.floor(Date.now() * Math.random())}`,
      title,
      ...options,
    };
    alerts.value.push(model);

    setTimeout(() => {
      alerts.value = alerts.value.filter((item) => {
        return item.id !== model.id;
      });
    }, 5000);
  }

  return {
    alerts,
    info,
  }
}
